import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import GeneralProposalContMain from "presentation/view/container/GeneralProposal/GeneralProposalContMain";

CommonEntrypoint(<GeneralProposalContMain/>)